import { NgModule } from '@angular/core';
import { TableStateStoreService } from './table-state.service';

@NgModule({
  imports: [],
  providers: [TableStateStoreService],
  exports: [],
})
export class TableStateStoreModule {}
